import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import MasonIt from "mason-it"

console.info("Bridgetown is loaded!")

//// Until grid-lanes is everywhere, do this!
if (location.pathname === "/" && !window.CSS.supports("display", "grid-lanes")) {
  console.info("Initializing MasonIt...")
  MasonIt.init("photo-grid > ul")
  document.querySelectorAll("photo-grid img").forEach(img => {
    img.addEventListener("load", () => MasonIt.refresh("photo-grid > ul"))
  })
}

//// We're gonna double poll this, just to be safe

setTimeout(() => {
  const activeEl = document.activeElement
  if (activeEl.dataset.isThumbnail === "") activeEl.blur()
}, 20)

setTimeout(() => {
  const activeEl = document.activeElement
  if (activeEl.dataset.isThumbnail === "") activeEl.blur()
}, 40)
